import React from "react";
import DataTable2 from "../Pages/DataTable2";
import "./home.css";

const Report = () => {
  return (
    <section className='home'>
      <div className='container'>
        <div className='heading flexSB'>
          <div className="flex items-center">            
          </div>
        </div>
        <DataTable2 />
      </div>
    </section>
  );
}

export default Report;
